import api from './api.service';

export default {
    createCustomerNote(data) {
        return api.post('/customer/customer-notes', data);
    },
    updateCustomerNote(noteId, data) {
        return api.put(`/customer/customer-notes/${noteId}`, data);
    },
    getCustomerNotes(customerId, companyId) {
        return api.get(`/customer/customer-notes?customerId=${customerId}&companyId=${companyId}`);
    },
    getCompanyCustomerNotes(companyId) {
        return api.get(`/customer/customer-notes?companyId=${companyId}`);
    },
    uploadCustomerNoteAttachments(noteId, companyId, formData) {
        return api.post(`/customer/customer-notes/${noteId}/attachments?companyId=${companyId}`, formData);
    },
    viewCustomerNoteAttachment(attachmentId, companyId) {
        return api.get(`/customer/customer-notes/attachments/${attachmentId}/view?companyId=${companyId}`, {
            responseType: 'blob'
        });
    },
    deleteCustomerNoteAttachment(attachmentId, companyId) {
        return api.delete(`/customer/customer-notes/attachments/${attachmentId}?companyId=${companyId}`);
    }
};
